module.exports = __webpack_public_path__ + "static/01-1cfd97aaefe987008b635ef19a7e4a82.jpg";